































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';

import CustomSelectMenu from '@/components/CustomSelect/CustomSelectMenu.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';

import DateUtils from '@/utils/DateUtils';
import eventBus from '@/utils/eventBus';

@Component({
  components: {
    CustomSelectMenu,
    CalendarIcon
  }
})
export default class DatePicker extends Vue {
  @Prop({ default: () => [] }) enabledDates!: string[];
  @Prop({ default: () => [] }) disabledDates!: string[];
  @Prop({ default: 2 }) monthToShow!: number;
  @Prop({ default: 'Date' }) placeholder!: string;
  @Prop() minDate!: string;
  @Prop({ default: 'range' }) mode!: string;
  @Prop({ default: false }) rightAlign!: boolean;
  @Prop({ default: false }) formStyle!: boolean;
  @Prop({ default: false }) updateMenuWithSelected!: boolean;
  @Prop() displayName!: string;
  @Prop({ default: '' }) dateStart!: string;
  @Prop({ default: '' }) dateEnd!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) limitMonthChanges!: boolean;
  @Prop({ default: false }) hasError!: boolean;
  @Prop({ default: false }) hideMenu!: boolean;
  @Prop({ default: false }) readOnly!: boolean;
  @Prop({ default: true }) required!: boolean;
  @Prop({ default: true }) left!: boolean;
  @Prop({ default: false }) highlightError!: boolean;
  @Prop({ default: false }) hasCalendarIcon?: boolean;

  @Inject('$validator') public $validator!: Validator;

  menuOpened: boolean = false;
  selectedOptionLabel: string = '';

  dateOne: string = '';
  dateTwo: string = '';

  previousMonthEnabled: boolean = true;
  nextMonthEnabled: boolean = true;

  created() {
    if (this.dateStart) {
      this.dateOne = this.dateStart.substr(0, 10);

      if (this.dateEnd) {
        this.dateTwo = this.dateEnd.substr(0, 10);
      }
    }

    this.monthChanged([
      this.dateOne
        ? this.dateOne
        : DateUtils.minimumDatePickerDate.toISOString().substr(0, 10)
    ]);

    this.bindEvents();
  }

  beforeDestroy() {
    this.unbindEvents();
  }

  bindEvents() {
    eventBus.$on('openPicker', this.openPicker);
  }

  unbindEvents() {
    eventBus.$off('openPicker', this.openPicker);
  }

  openPicker() {
    if (this.readOnly) return;
    this.menuOpened = true;
  }

  monthChanged(visibleMonths: string[]) {
    if (this.limitMonthChanges && visibleMonths.length) {
      const current: Date = new Date(visibleMonths[0]);
      const monthSize: number = 30 * 24 * 60 * 60 * 1000;
      const nextMonth: Date = new Date(current.getTime() + monthSize);

      this.previousMonthEnabled = current > DateUtils.minimumDatePickerDate;
      this.nextMonthEnabled = nextMonth < DateUtils.maximumCalendarDate;
    }
  }

  updateDateOne(value: string) {
    this.dateOne = value;

    this.updateLabel();
    if (this.mode == 'single') {
      this.$emit('changed', this.dateOne);
    }
  }

  updateDateTwo(value: string) {
    this.dateTwo = value;
    this.updateLabel();
    if (this.dateOne && this.dateTwo && this.mode !== 'single') {
      this.$emit('changed', this.dateOne, this.dateTwo);
    }
  }

  updateLabel() {
    this.selectedOptionLabel = this.updateMenuWithSelected
      ? this.mode == 'single'
        ? `${DateUtils.formatDateString(this.dateOne)}`
        : `${DateUtils.formatDateString(
            this.dateOne
          )} - ${DateUtils.formatDateString(this.dateTwo)}`
      : '';
  }

  menuChanged(value: boolean) {
    if (this.readOnly) return;
    setTimeout(() => {
      this.menuOpened = value;
    }, 50);
  }

  datePickerOpened() {}

  datePickerClosed() {
    this.menuOpened = false;
  }
}
